<template>
	<div class="spe-split" :style="commonStyle" :ddt-area="`component_${json.floorId}`" ddt-expose="on">
		<div :style="lineStyle"></div>
	</div>
</template>

<script>
export default {
	props: {
		json: {
			type: Object,
			default: () => {
				return {};
			}
        },
        pagebgcolor: ""
	},
	components: {},
	data() {
		return {};
	},
	computed: {
		jdata() {
			return this.json.data || { commonStyle: {}, tabStyle: {}, tabsData: [] };
		},
		commonStyle() {
			let sty = {
				padding: `0 ${this.jdata.commonStyle.margin}px`
			};
      if (this.jdata.commonStyle.backgroundType == 2) {
        //背景图
        sty.backgroundImage = `url(${this.jdata.commonStyle.backgroundImage})`;
      } else if(this.jdata.commonStyle.backgroundType == 1){
        if (this.jdata.commonStyle.usePageBackgroundColor) {
          sty.backgroundColor =this.jdata.commonStyle.bgColor
        }else{
          sty.backgroundColor = this.jdata.commonStyle.backgroundColor;
        }
      }
      return sty;
		},
		lineStyle() {
			let sty = {
				height: this.jdata.lineHeight + "px",
                margin: `${this.jdata.upDownMargin}px 0`
            }

            if( this.jdata.useBgColor ){
                sty.backgroundColor=this.pagebgcolor
            }else{
                sty.backgroundColor=this.jdata.color || this.jdata.defaultColor
            }

            return sty
		}
	},
	watch: {},
	mounted() {},
	methods: {},
	filters: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.spe-split {
    display: flex;
    background-repeat: no-repeat;
    background-position: left top;
    background-size: 100% 100%;
    div{
        flex:1;
    }
}
</style>
